export const STREAM_ESTATE_ENTRY_POINTS = {
  PUBLIC_PAGE: 'public_page',
  SIDEBAR_LOGGEDOUT: 'sidebar_loggedout',
  SIDEBAR_LOGGEDIN: 'sidebar_loggedin',
  SETTINGS_TAB: 'settings_tab',
  API_KEYS_BANNER: 'api_keys_banner',
}

export const STREAM_ESTATE_DOCS_URL = 'https://docs.stream.estate'

export function buildStreamEstateLink(entryPoint) {
  const params = new URLSearchParams({
    utm_source: 'melo',
    utm_medium: 'app',
    utm_campaign: 'api_redirect',
    utm_content: entryPoint,
    from: 'melo',
  })
  return `https://stream.estate/fr/?${params.toString()}`
}
